import React from 'react'

export const LiveMatches = () => {
  return (
    <div>Live matches</div>
  );
};
